import React, { useState } from "react";
import Marcador from "../marcador/index";
import { BsArrowLeft, BsFillQuestionCircleFill } from "react-icons/bs";
import Cards from "react-credit-cards";
import "react-credit-cards/es/styles-compiled.css";
import AcordeonContrata from "./accordion/index";
import { Link } from "react-scroll";
import Container from "./styled";
import valid from "card-validator";
import axios from "axios";
import IkeModalSwitch from "./ikeModal/switch";

export default class Contrata extends React.Component {
  state = {
    isOpen: false,
  };

  // Toggle pora cambiar el estado que determina si el pop-up esta abierto o no
  togglePopup = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  constructor(props) {
    super(props);
    console.log(props);

    // Mostrar u ocultar forma de pago
    this.state = {
      // value: "Forma de pago",
      // Trae los datos que ya estan desde el paso 1 en el localStorage
      cvc: "",
      expiry: "",
      focus: "",
      name: "",
      number: "",
      nombre: localStorage.getItem("nombre"),
      apellido: localStorage.getItem("apellido"),
      cuitDNI: "",
      codigo_postal: "",
      localidad: localStorage.getItem("localidad"),
      email: localStorage.getItem("email"),
      codigo_area: localStorage.getItem("codigoArea"),
      telefono: localStorage.getItem("telefono"),
      marca: "",
      modelo: "",
      suma_asegurada: "",
      cbu: "",
      dniTarjeta: "",
      banco: "",
      formaDePago: "",
      formErrors: {},
      prefijos: "",
      tipo_tarjeta: "",
    };
    this.handleOptionChange = this.handleOptionChange.bind(this);
  }

  async componentDidMount() {
    const codigos_area = await axios.get(
      "https://heroku-gys-server-test.herokuapp.com/prefijos"
    );
    this.setState({ prefijos: codigos_area.data });
    console.log(codigos_area.data);
  }

  // Tarjeta
  handleInputFocus = (e) => {
    this.setState({ focus: e.target.name });
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
    // Condicional para no guardar ningun tipo de dato de pago en el localStorage
    if (
      name != "cvc" &&
      name != "expiry" &&
      name != "name" &&
      name != "suma_asegurada" &&
      name != "formaDePago" &&
      name != "cbu" &&
      name != "dniTarjeta" &&
      name != "banco"
    ) {
      // Guarda el valor de cada input en el localStorage con su nombre para autocompletar los modales de baja y arrepentimiento
      localStorage.setItem([name], value);
    }
  };

  // Mostrar u ocultar forma de pago
  handleOptionChange(e) {
    this.setState({ value: e.target.value });
  }

  checkCP = async () => {
    if (this.state.codigo_postal && this.state.localidad) {
      const validateCp = await axios.get(
        "https://get-arg-cp-api.vercel.app/validate",
        {
          params: {
            provincia: "Buenos Aires",
            localidad: this.state.localidad,
            localidad_censal: "",
            departamento: "",
            municipio: "",
            codigo_postal: this.state.codigo_postal,
          },
        }
      );
      console.log(validateCp);
    }
  };

  // Validación de errores en el formulario
  checkErrors = async () => {
    // Objeto que almacena los errores según el campo
    let errors = {};

    console.log("PROPS");
    console.log(this.props);
    console.log(this.props.idCotizacion);
    console.log(this.props.idContrata);

    // Nombre
    if (!this.state.nombre) {
      errors.nombre = "Este campo es requerido.";
    } else if (this.state.nombre.length < 2) {
      errors.nombre = "El campo debe contener al menos 2 caracteres.";
    } else if (
      !/^[a-zA-Z\u00C0-\u017F!@#$%^&':"\\|,.<>\/?\s\u00f1\u00d1]*$/.test(
        this.state.nombre
      )
    ) {
      errors.nombre = "El nombre ingresado no es válido.";
    }

    // Apellido
    if (!this.state.apellido) {
      errors.apellido = "Este campo es requerido.";
    } else if (this.state.apellido.length < 2) {
      errors.apellido = "El campo debe contener al menos 2 caracteres.";
    } else if (
      !/^[a-zA-Z!@#$%^&':"\\|,.<>\/?\s\u00f1\u00d1]*$/.test(this.state.apellido)
    ) {
      errors.apellido = "El apellido ingresado no es válido.";
    }

    // CUIT / DNI
    if (!this.state.cuitDNI) {
      errors.cuitDNI = "Este campo es requerido.";
    } else if (
      this.state.cuitDNI.length < 8 ||
      this.state.cuitDNI.length > 11
    ) {
      errors.cuitDNI = "El CUIT/DNI es inválido.";
    }

    // Localidad
    if (!this.state.localidad) {
      errors.localidad = "Este campo es requerido.";
    }

    // Código Postal
    if (!this.state.codigo_postal) {
      errors.codigo_postal = "Este campo es requerido.";
    }
    /*
    else if (this.state.codigo_postal && this.state.localidad) {
      const validateCp = await axios.get(
        "https://get-arg-cp-api.vercel.app/validate",
        {
          params: {
            provincia: "Buenos Aires",
            localidad: this.state.localidad,
            localidad_censal: "",
            departamento: "",
            municipio: "",
            codigo_postal: this.state.codigo_postal,
          },
        }
      );
      if (validateCp.data.isValid === false) {
        errors.codigo_postal = "El código postal ingresado no es válido.";
      }
    }
     */

    // Email
    if (!this.state.email) {
      errors.email = "Este campo es requerido";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.state.email)) {
      errors.email = "El email ingresado no es valido.";
    }

    // Código de área
    if (!this.state.codigo_area) {
      errors.codigo_area = "Este campo es requerido";
    } else if (
      this.state.codigo_area.length < 2 ||
      this.state.codigo_area.length > 5
    ) {
      errors.codigo_area =
        "El código de área debe tener más de 2 digitos y menos de 5.";
    } else {
      const checkPrefix = this.state.prefijos.some((prefix) => {
        return this.state.codigo_area === prefix.prefijo;
      });
      if (!checkPrefix) {
        errors.codigo_area = "El código de área ingresado no es válido.";
      }
    }

    // Teléfono
    if (!this.state.telefono) {
      errors.telefono = "Este campo es requerido";
    } else if (this.state.telefono.length < 8) {
      errors.telefono = "El campo telefono es menor a 8 digitos.";
    }

    // Marca
    if (!this.state.marca) {
      errors.marca = "Este campo es requerido";
    }

    // Modelo
    if (!this.state.modelo) {
      errors.modelo = "Este campo es requerido";
    }

    // Suma Asegurada
    if (!this.state.suma_asegurada) {
      errors.suma_asegurada = "Este campo es requerido";
    }

    // Forma de Pago
    if (!this.state.formaDePago) {
      errors.formaDePago = "Este campo es requerido";
    } else {
      // Tarjeta de crédito
      if (this.state.formaDePago === "Tarjeta de credito") {
        // Titular de la tarjeta
        if (!this.state.name) {
          errors.name = "Este campo es requerido";
        } else {
          let validName = valid.cardholderName(this.state.name);
          if (!validName.isValid) {
            errors.name = "El nombre ingresado no es válido.";
          }
          if (this.state.name.length < 2) {
            errors.name =
              "El campo Titular de la tarjeta debe contener al menos 2 caracteres";
          } else if (
            !/^[A-Za-z'\s\u00f1\u00d1\u00C0-\u017F]+$/.test(this.state.name)
          ) {
            errors.name = "El nombre ingresado no es válido.";
          }
        }

        // Número de tarjeta
        if (!this.state.number) {
          errors.number = "Este campo es requerido";
        } else if (
          this.state.number.startsWith("4517") ||
          this.state.number.startsWith("4815") ||
          this.state.number.startsWith("5285")
        ) {
          errors.numero =
            "El número de tarjeta ingresado corresponde a una tarjeta de debito.";
        } else {
          let validNumber = valid.number(this.state.number);
          console.log(validNumber);
          if (!validNumber.isValid) {
            errors.numero = "El número de tarjeta ingresado no es válido.";
          } else {
            this.setState({ tipo_tarjeta: validNumber.card.niceType });
          }
        }

        // Fecha de vencimiento
        if (!this.state.expiry) {
          errors.expiry = "Este campo es requerido";
        } else {
          let validExpiry = valid.expirationDate(this.state.expiry);
          if (!validExpiry.isValid) {
            errors.expiry = "La fecha de vencimiento ingresada no es válida.";
          }
        }

        // DNI
        if (!this.state.dniTarjeta) {
          errors.dniTarjeta = "Este campo es requerido";
        } else if (this.state.dniTarjeta.length !== 8) {
          errors.dniTarjeta = "El campo DNI solo permite 8 digitos.";
        }

        // Banco Emisor
        if (!this.state.banco) {
          errors.banco = "Este campo es requerido";
        } else if (!/^[A-Za-z'\s\u00C0-\u017F]+$/.test(this.state.banco)) {
          errors.banco = "El Banco emisor ingresado no es válido.";
        }
      } else if (this.state.formaDePago === "Transferencia bancaria") {
        let notValid = ["0143", "0147", "0158", "0165", "0384", "000000"];

        notValid.forEach((number) => {
          if (this.state.cbu.startsWith(number)) {
            errors.cbu = "CBU no bancarizado.";
          }
        });

        // CBU
        if (!this.state.cbu) {
          errors.cbu = "Este campo es requerido";
        } else if (this.state.cbu.length !== 22) {
          errors.cbu = `El CBU ingresado debe contener 22 digitos. El valor ingresado tiene ${this.state.cbu.length} digitos.`;
        }
      }
    }

    this.setState({ formErrors: errors });

    // Si el objeto errors está vacío, ir al paso siguiente.
    if (Object.keys(errors).length === 0) {
      this.sendData();
      this.props.nextStep();
    }
  };

  sendData = async () => {

    let plan;
    switch(this.props.planSelected.plan){
      case "Plan Gold": 
        plan = "gold"
        break
      case "Plan Platinum":
        plan = "platinum"
        break
      case "Plan Standard":
        plan = "segunda_standard"
        break
    }

    const validNumber = valid.number(this.state.number);
    const tarjeta = validNumber.card.niceType

    const data = {
      id_contrata: this.props.idContrata,
      id_cotizacion: this.props.idCotizacion,
      nombre: `${this.state.nombre} ${this.state.apellido}`,
      email: this.state.email,
      tel: this.state.telefono,
      localidad: this.state.localidad, 
      fch_nacimiento: "",
      cuit: this.state.cuitDNI,
      postal: this.state.codigo_postal,
      landing: "bici",
      marca: `${this.state.marca} ${this.state.modelo}`,
      valor: this.state.suma_asegurada,
      bicicleteria: '',
      plan: plan,
      forma_pago:
        this.state.formaDePago === "Tarjeta de credito"
          ? 1
          : this.state.formaDePago === "Transferencia bancaria"
          ? 2
          : 3,
      tipo_pago: tarjeta,
      numero_tarjeta: this.state.number,
      vto_tarjeta: this.state.expiry,
      numero_cbu: this.state.cbu,
      tipo: "comun",
      nombre_titular: this.state.name,
      dni_tarjeta: this.state.dniTarjeta
    };
    console.log("DATA ENVIADA AL BACK")
    console.log(data)
    const post = await axios.post(
      "http://localhost:5000/insert_cotizacion",
      data
    );
  };

  render() {
    const isOpen = this.state.isOpen;

    // Next Step
    const Continue = (e) => {
      e.preventDefault();
      this.props.nextStep();
    };

    // Prev Step
    const Previous = (e) => {
      e.preventDefault();
      this.props.prevStep();
    };

    return (
      <Container>
        {/* Marcador pasos */}
        <Marcador pasoDos="hecho" pasoTres="activo"></Marcador>
        {/* Back button */}
        <div className="backButton">
          <button onClick={Previous}>
            <span>
              <BsArrowLeft />
            </span>
            Volvé a elegir
          </button>
        </div>
        {/* Formulario */}
        <form className="topInOpacity5">
          {/* Seguro seleccionado */}
          <AcordeonContrata
            // Seguro
            seguro={this.props.planSelected.seguro}
            // Logo del seguro
            logo={this.props.planSelected.logo}
            // Nombre del plan
            plan={this.props.planSelected.plan}
            // Checks
            resCivil={this.props.planSelected.resCivil}
            roboTotal={this.props.planSelected.roboTotal}
            roboParcial={this.props.planSelected.roboParcial}
            desTotal={this.props.planSelected.desTotal}
            asistencia={this.props.planSelected.asistencia}
            competencias={this.props.planSelected.competencias}
            // Precios
            cuotas={this.props.planSelected.cuotas}
            precioAnterior={this.props.planSelected.precioAnterior}
            oferta={this.props.planSelected.oferta}
            precio={this.props.planSelected.precio}
            contratando={this.props.planSelected.contratando}
          ></AcordeonContrata>
          {/* CheckBox Ike */}
          <div className="checkBoxIke">
            <div className="checkBoxContainer">
              <input type="checkbox" id="checkbox" name="ike" />
              <label>
                Quiero contratar el Plan Asistencia Full Bici de Iké Asistencia
                <br />
                Vigencia Anual - <span>12 cuotas mensuales de $400 c/u.</span>
              </label>
            </div>
            <a onClick={this.togglePopup}>
              <span>
                <BsFillQuestionCircleFill />
              </span>
              ¿Que cubre Iké Asistencia?
            </a>
            <div className="ikeDataContainer">
              <div>
                <img alt="Ike Asistencia Logo" src="images/logos/ike.svg" />
              </div>
              <p>
                A tu SeguroBici. agregale muchos más beneficios de cobertura e
                increibles descuentos en servicios para tu bici. Sumale Ike
                Asistencia a tu poliza y sentite mas seguro que nunca,
                comprometidos a brindar servicios de excelencia con personal
                especializado y recursos de vanguardia.
              </p>
            </div>
          </div>
          {/* Datos Personales */}
          <div className="datosPersonales">
            <p>Datos personales</p>
            {/* Nombre */}
            <div className="inputContainer">
              <label
                className={
                  this.state.formErrors.nombre == null ? "" : "labelError"
                }
              >
                Nombre
              </label>
              <input
                placeholder="Nombre"
                name="nombre"
                value={this.state.nombre}
                onChange={this.handleInputChange}
                className={
                  this.state.formErrors.nombre == null ? "" : "inputError"
                }
              ></input>
              {this.state.formErrors.nombre && (
                <span>{this.state.formErrors.nombre}</span>
              )}
            </div>
            {/* Apellido */}
            <div className="inputContainer">
              <label
                className={
                  this.state.formErrors.apellido == null ? "" : "labelError"
                }
              >
                Apellido
              </label>
              <input
                placeholder="Apellido"
                name="apellido"
                value={this.state.apellido}
                onChange={this.handleInputChange}
                className={
                  this.state.formErrors.apellido == null ? "" : "inputError"
                }
              ></input>
              {this.state.formErrors.apellido && (
                <span>{this.state.formErrors.apellido}</span>
              )}
            </div>
            {/* CUIT / DNI */}
            <div className="inputContainer" id="cuitDni">
              <label
                className={
                  this.state.formErrors.cuitDNI == null ? "" : "labelError"
                }
              >
                CUIT / DNI
              </label>
              <input
                placeholder="CUIT / DNI"
                name="cuitDNI"
                value={this.state.cuitDNI}
                onChange={this.handleInputChange}
                className={
                  this.state.formErrors.cuitDNI == null ? "" : "inputError"
                }
              ></input>
              {this.state.formErrors.cuitDNI && (
                <span>{this.state.formErrors.cuitDNI}</span>
              )}
            </div>
            {/* Codigo Postal */}
            <div className="inputContainer" id="codPostal">
              <label
                className={
                  this.state.formErrors.codigo_postal == null
                    ? ""
                    : "labelError"
                }
              >
                Cod. Postal
              </label>
              <input
                placeholder="1008"
                name="codigo_postal"
                value={this.state.codigo_postal}
                onChange={this.handleInputChange}
                className={
                  this.state.formErrors.codigo_postal == null
                    ? ""
                    : "inputError"
                }
              ></input>
              {this.state.formErrors.codigo_postal && (
                <span>{this.state.formErrors.codigo_postal}</span>
              )}
            </div>
            {/* Select Localidad */}
            <div className="inputContainer">
              <label
                className={
                  this.state.formErrors.localidad == null ? "" : "labelError"
                }
              >
                Localidad
              </label>
              {/* Select Container */}
              <div className="selectContainer">
                <select
                  name="localidad"
                  value={this.state.localidad}
                  onChange={this.handleInputChange}
                  className={
                    this.state.formErrors.localidad == null ? "" : "inputError"
                  }
                >
                  {/* Opción por predeterminado */}
                  <option disabled selected>
                    Localidad
                  </option>
                  <option value="Capital Federeal y Gran Buenos Aires">
                    Capital Federal y Gran Buenos Aires
                  </option>
                  <option value="Berisso">Berisso</option>
                  <option value="Ensenada">Ensenada</option>
                  <option value="Belen de Escobar">Escobar</option>
                  <option value="Exaltacion de la Cruz">
                    Exaltación de la Cruz
                  </option>
                  <option value="General Rodriguez">General Rodriguez</option>
                  <option value="La Plata">La Plata</option>
                  <option value="Lujan">Luján</option>
                  <option value="Marcos Paz">Marcos Paz</option>
                  <option value="Merlo">Merlo</option>
                  <option value="Moreno">Moreno</option>
                  <option value="Pilar">Pilar</option>
                  <option value="San Vicente">San Vicente</option>
                  <option value="Resto del Pais">Resto del País</option>
                </select>
                <i></i>
              </div>
              {this.state.formErrors.localidad && (
                <span>{this.state.formErrors.localidad}</span>
              )}
            </div>
            {/* Email */}
            <div className="inputContainer">
              <label
                className={
                  this.state.formErrors.email == null ? "" : "labelError"
                }
              >
                Email
              </label>
              <input
                placeholder="ejemplo@mail.com"
                name="email"
                value={this.state.email}
                onChange={this.handleInputChange}
                className={
                  this.state.formErrors.email == null ? "" : "inputError"
                }
              ></input>
              {this.state.formErrors.email && (
                <span>{this.state.formErrors.email}</span>
              )}
            </div>
            {/* Cod. Área */}
            <div className="inputContainer" id="codArea">
              <label
                className={
                  this.state.formErrors.codigo_area == null ? "" : "labelError"
                }
              >
                Cod. Área
              </label>
              <input
                placeholder="011"
                name="codigo_area"
                value={this.state.codigo_area}
                onChange={this.handleInputChange}
                className={
                  this.state.formErrors.codigo_area == null ? "" : "inputError"
                }
              ></input>
              {this.state.formErrors.codigo_area && (
                <span>{this.state.formErrors.codigo_area}</span>
              )}
            </div>
            {/* Telefono */}
            <div className="inputContainer" id="telefono">
              <label
                className={
                  this.state.formErrors.telefono == null ? "" : "labelError"
                }
              >
                Teléfono
              </label>
              <input
                placeholder="45892357"
                name="telefono"
                value={this.state.telefono}
                onChange={this.handleInputChange}
                className={
                  this.state.formErrors.telefono == null ? "" : "inputError"
                }
              ></input>
              {this.state.formErrors.telefono && (
                <span>{this.state.formErrors.telefono}</span>
              )}
            </div>
          </div>
          {/* Datos de la bicicleta */}
          <div className="datosBicicleta">
            <p>Datos de la bicicleta</p>
            {/* Marca y modelo */}
            <div className="inputContainer">
              <label
                className={
                  this.state.formErrors.marca == null ? "" : "labelError"
                }
              >
                Marca
              </label>
              <input
                placeholder="Marca"
                name="marca"
                value={this.state.marca}
                onChange={this.handleInputChange}
                className={
                  this.state.formErrors.marca == null ? "" : "inputError"
                }
              ></input>
              {this.state.formErrors.marca && (
                <span>{this.state.formErrors.marca}</span>
              )}
            </div>
            {/* Modelo */}
            <div className="inputContainer">
              <label
                className={
                  this.state.formErrors.modelo == null ? "" : "labelError"
                }
              >
                Modelo
              </label>
              <input
                placeholder="Modelo"
                name="modelo"
                value={this.state.modelo}
                onChange={this.handleInputChange}
                className={
                  this.state.formErrors.modelo == null ? "" : "inputError"
                }
              ></input>
              {this.state.formErrors.modelo && (
                <span>{this.state.formErrors.modelo}</span>
              )}
            </div>
            {/* Suma asegurada */}
            <div className="inputContainer">
              <label
                className={
                  this.state.formErrors.suma_asegurada == null
                    ? ""
                    : "labelError"
                }
              >
                Suma asegurada
              </label>
              <input
                placeholder="Suma asegurada"
                name="suma_asegurada"
                value={this.state.suma_asegurada}
                onChange={this.handleInputChange}
                className={
                  this.state.formErrors.suma_asegurada == null
                    ? ""
                    : "inputError"
                }
              ></input>
              {this.state.formErrors.suma_asegurada && (
                <span>{this.state.formErrors.suma_asegurada}</span>
              )}
            </div>
          </div>
          {/* Cobertura y forma de pago */}
          <div className="coberturaPago">
            <p>Cobertura y forma de pago</p>
            {/* Plan */}
            <div className="inputContainer">
              <label>Plan</label>
              <div className="selectContainer">
                <select name="plan">
                  {/* Opción por predeterminado */}
                  <option disabled selected>
                    {this.props.planSelected.plan}
                  </option>
                </select>
                <i></i>
              </div>
            </div>
            {/* Forma de pago */}
            <div className="inputContainer">
              <label
                className={
                  this.state.formErrors.formaDePago == null ? "" : "labelError"
                }
              >
                Forma de pago
              </label>
              {/* Select Forma de pago */}
              <div className="selectContainer">
                <select
                  name="formaDePago"
                  value={this.state.value}
                  onChange={this.handleInputChange}
                  className={
                    this.state.formErrors.formaDePago == null
                      ? ""
                      : "inputError"
                  }
                >
                  {/* Opción por predeterminado */}
                  <option disabled selected>
                    Forma de pago
                  </option>
                  <option value="Tarjeta de credito">Tarjeta de credito</option>
                  <option value="Transferencia bancaria">
                    Transferencia bancaria
                  </option>
                </select>
                <i></i>
              </div>
              {this.state.formErrors.formaDePago && (
                <span>{this.state.formErrors.formaDePago}</span>
              )}
            </div>
            {/* CBU */}
            {this.state.formaDePago == "Transferencia bancaria" && (
              <div className="inputContainer topInOpacity5">
                <label
                  className={
                    this.state.formErrors.cbu == null ? "" : "labelError"
                  }
                >
                  CBU
                </label>
                <input
                  placeholder="CBU"
                  name="cbu"
                  value={this.state.cbu}
                  onChange={this.handleInputChange}
                  className={
                    this.state.formErrors.cbu == null ? "" : "inputError"
                  }
                ></input>
                {this.state.formErrors.cbu && (
                  <span>{this.state.formErrors.cbu}</span>
                )}
              </div>
            )}
          </div>
          {/* Card Container */}
          {this.state.formaDePago == "Tarjeta de credito" && (
            <div className="tarjetaContainer topInOpacity5">
              {/* Card */}
              <Cards
                cvc={this.state.cvc}
                expiry={this.state.expiry}
                focused={this.state.focus}
                name={this.state.name}
                number={this.state.number}
                placeholders={{
                  name: "TU NOMBRE ACÁ",
                  expiryValid: "expira",
                }}
              />
              {/* Nuemero de tarjeta */}
              <div className="inputContainer">
                <label
                  className={
                    this.state.formErrors.number == null ? "" : "labelError"
                  }
                >
                  Número de tarjeta
                </label>
                <input
                  type="tel"
                  placeholder="Número de tarjeta"
                  name="number"
                  onChange={this.handleInputChange}
                  onFocus={this.handleInputFocus}
                  className={
                    this.state.formErrors.number == null ? "" : "inputError"
                  }
                ></input>
                {this.state.formErrors.number && (
                  <span>{this.state.formErrors.number}</span>
                )}
              </div>
              {/* Fecha de vencimiento */}
              <div className="inputContainer" id="vencimiento">
                <label
                  className={
                    this.state.formErrors.expiry == null ? "" : "labelError"
                  }
                >
                  Fecha de vencimiento
                </label>
                <input
                  type="tel"
                  placeholder="MM/AA"
                  name="expiry"
                  onChange={this.handleInputChange}
                  onFocus={this.handleInputFocus}
                  className={
                    this.state.formErrors.expiry == null ? "" : "inputError"
                  }
                ></input>
                {this.state.formErrors.expiry && (
                  <span>{this.state.formErrors.expiry}</span>
                )}
              </div>
              {/* Titular de la tarjeta */}
              <div className="inputContainer">
                <label
                  className={
                    this.state.formErrors.name == null ? "" : "labelError"
                  }
                >
                  Titular de la tarjeta
                </label>
                <input
                  type="text"
                  placeholder="Titular de la tarjeta"
                  name="name"
                  onChange={this.handleInputChange}
                  onFocus={this.handleInputFocus}
                  className={
                    this.state.formErrors.name == null ? "" : "inputError"
                  }
                ></input>
                {this.state.formErrors.name && (
                  <span>{this.state.formErrors.name}</span>
                )}
              </div>
              {/* DNI */}
              <div className="inputContainer">
                <label
                  className={
                    this.state.formErrors.dniTarjeta == null ? "" : "labelError"
                  }
                >
                  DNI
                </label>
                <input
                  placeholder="DNI"
                  name="dniTarjeta"
                  value={this.state.dniTarjeta}
                  onChange={this.handleInputChange}
                  className={
                    this.state.formErrors.dniTarjeta == null ? "" : "inputError"
                  }
                ></input>
                {this.state.formErrors.dniTarjeta && (
                  <span>{this.state.formErrors.dniTarjeta}</span>
                )}
              </div>
              {/* Banco Emisor */}
              <div className="inputContainer">
                <label
                  className={
                    this.state.formErrors.banco == null ? "" : "labelError"
                  }
                >
                  Banco emisor
                </label>
                <input
                  placeholder="Banco emisor"
                  name="banco"
                  value={this.state.banco}
                  onChange={this.handleInputChange}
                  className={
                    this.state.formErrors.banco == null ? "" : "inputError"
                  }
                ></input>
                {this.state.formErrors.banco && (
                  <span>{this.state.formErrors.banco}</span>
                )}
              </div>
            </div>
          )}
          {/* Button Contratá */}
          <div className="buttonContainer">
            <Link onClick={this.checkErrors} to="header" spy={true}>
              Contratar seguro
            </Link>
          </div>
          {/* Cobertura uso laboral */}
          <p id="coberturaLaboral">
            *Las coberturas son unicamente para uso particular. ¿Trabajas con la
            Bici?{" "}
            <a href="https://www.segurobici.com.ar/seguro-de-bici-uso-comercial/">
              {" "}
              Cotizá una cobertura especial para uso comercial
            </a>
          </p>
        </form>
        {this.state.isOpen && <IkeModalSwitch handleClose={this.togglePopup} />}
      </Container>
    );
  }
}
